import { AwesomeEvent, ComponentAPI, Value } from '@philips-emr/tws-core';
import { Renderable, RenderEventListener } from '@philips-emr/tws-core/lib/component/types';

import { HpmsCustomCardEventListener, HpmsCustomCardMenuRenderEventListener, HpmsCustomCardType } from '../../types';

export const DYNAMIC_CONTENT_TYPE = 'hpms-custom-card-dynamic-content';
export const ACTION_TYPE = 'hpms-custom-card-action';

export default class HpmsCustomCardApi extends ComponentAPI<any> implements HpmsCustomCardType<Record<string, Value>>, Renderable {

  @AwesomeEvent
  onOpen = new HpmsCustomCardEventListener<Record<string, Value>>();

  /** @event */
  @AwesomeEvent
  onDynamicContentRender = new RenderEventListener();

  /** @event */
  @AwesomeEvent
  onCreateOption = new HpmsCustomCardMenuRenderEventListener<Record<string, Value>>();

  /** @event */
  @AwesomeEvent
  onOptionClick = new HpmsCustomCardEventListener<Record<string, Value>>();

  /** @event */
  @AwesomeEvent
  onCreateMenu = new HpmsCustomCardMenuRenderEventListener<Record<string, Value>>();

  /** @event */
  @AwesomeEvent
  onRenderAction = new RenderEventListener();

  /** @event */
  @AwesomeEvent
  onClickHeader = new HpmsCustomCardEventListener<Record<string, Value>>();

  public getState(): Record<string, Value> {
    return this.state;
  }

  public isCollapsed(): boolean {
    return this.collapsed;
  }

  public setCollapsed(value: boolean): void {
    this.setState({ collapsed: value });
  }

}
